<template>
  <div style="height: 100%;">

    <header class="row align-items-center no-margin">
      <div class="col">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')">
          <i class="fas fa-chevron-left"/>
        </button>
      </div>
    </header>

    <section class="orders-section">
      <orderlist-view
        class="order-list"
        disabled="true"/>
      <totalprice-view
        class="total-price"
        disabled="true"
        style="border-top: solid 1px #F2F2F2;"/>
    </section>

    <section class="payment-section">
      <div
        v-if="posSettings.payment.is_active"
        class="wrapper-payment-methods"
      >
        <div class="col no-padding mb-2 title">
          {{ $t('apps.pos.message.paymentmethod') }}:
        </div>
        <div>
          <div
            class="btn-group btn-group-payment-methods"
            role="group">
            <button
              v-for="(item, index) in paymentMethodsButtons"
              :key="index"
              :class="item.btnClass"
              type="button"
              @click="handleSelectPaymentMethod(item.name)"
            >
              {{ item.text }}
            </button>
          </div>
        </div>
        <div class="col no-padding mt-2 helper">
          <i
            class="fa fa-info-circle"
            aria-hidden="true"/>
          <span>
            {{ $t('apps.pos.message.paymentmethodhelper') }}
          </span>
        </div>
      </div>
      <div class="wrapper-payment-form">
        <calculator-view
          v-if="paymentMethod === POS_PAYMENT_METHOD.CASH"
          :compare="true"
          :disabled="disabledBtnEnter"
          @submit="onSubmit"
        />
        <other-payment-form
          v-else
          :total="totalPrice"
          :paymentMethod="paymentMethod"
          :disabled="disabledBtnEnter"
          @submit="onSubmit"
        />
      </div>
    </section>
  </div>
</template>

<script>
import paymentMixin from '@/mixins/pos/payment'

export default {
  mixins: [paymentMixin],
}
</script>

<style scoped>
  .orders-section, .payment-section {
    height: -webkit-calc(100% - 8px);
  	height:    -moz-calc(100% - 8px);
  	height:         calc(100% - 8px);
  }
  .orders-section {
    width: 334px;
    float: left;
    margin-top: 8px;
    background: #fff;
    border: solid 1px #F2F2F2;
  }
  .payment-section {
    width: -webkit-calc(100% - 334px );
  	width:    -moz-calc(100% - 334px );
  	width:         calc(100% - 334px );
    float: left;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
  .payment-section .wrapper-payment-form {
    width: 90%;
    height: 500px;
  }

  .payment-section .wrapper-payment-methods {
    width: 90%;
  }

  .payment-section .wrapper-payment-methods .title {
    font-size: 14px;
  }

  .payment-section .wrapper-payment-methods .helper {
    font-size: 13px;
    color: #ccc;
  }

  .btn-group-payment-methods {
    display: flex;
    max-width: 100%;
    overflow-x: auto;
  }

  .btn-group-payment-methods .btn {
    flex: 1;
    font-size: 18px;
    box-shadow: none;
  }

  body[device="desktop"] .btn-group-payment-methods .btn {
    height: 50px;
  }

  @media (min-width: 1023px) {
    .payment-section .wrapper-payment-form {
      width: 600px;
      height: 500px;
    }

    .payment-section .wrapper-payment-methods {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/Payment.vue